const tableExpandLinks = document.querySelectorAll('.account-box__expand-link');

if (tableExpandLinks) {
    tableExpandLinks.forEach(link => {
        link.addEventListener('click', () => {
            const tableId = link.getAttribute('aria-controls');
            const hiddenTableRows = document
                .getElementById(tableId)
                .querySelectorAll('.account-box-list__item--hidden');
            hiddenTableRows.forEach(row => {
                row.classList.remove('account-box-list__item--hidden');
            });
            link.remove();
        });
    });
}
